import { render, staticRenderFns } from "./ViewSingleEmail.vue?vue&type=template&id=92a133b2&scoped=true&"
import script from "./ViewSingleEmail.vue?vue&type=script&lang=ts&"
export * from "./ViewSingleEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ViewSingleEmail.vue?vue&type=style&index=0&id=92a133b2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a133b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VChipGroup,VCol,VIcon,VRow})
